import { render } from "./SecondaryActions.vue?vue&type=template&id=2152e5fc&scoped=true"
import script from "./SecondaryActions.vue?vue&type=script&lang=js"
export * from "./SecondaryActions.vue?vue&type=script&lang=js"

import "@/Common/Styles/secondaryActions.scss?vue&type=style&index=0&id=2152e5fc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2152e5fc"]])

export default __exports__